import React from 'react';
import PropTypes from 'prop-types';
import BaseIcon from '../../utils/BaseIcon';

const CloseSystemIcon = props => {
  const iconFill = 'currentColor';
  return (
    <BaseIcon {...props}>
      <path fill={iconFill} fillRule="evenodd" d="M19.736 3.22a.75.75 0 111.06 1.06L13.1 11.978l8.758 8.758a.75.75 0 01-1.06 1.06l-8.759-8.758-8.758 8.758a.75.75 0 11-1.06-1.06l8.758-8.758L3.28 4.28a.75.75 0 011.061-1.06l7.697 7.697 7.698-7.697z" clipRule="evenodd"/>
    </BaseIcon>
  );
};

CloseSystemIcon.displayName = 'CloseSystemIcon';

CloseSystemIcon.propTypes = {
  theme: PropTypes.object,
  size: PropTypes.oneOfType([PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"]), PropTypes.number]),
  fill: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
}

CloseSystemIcon.defaultProps = {
  size: 24
};

CloseSystemIcon.displayName = 'CloseSystemIcon';
CloseSystemIcon.iconName = 'Close';

export default CloseSystemIcon;
